import { useTranslation } from 'react-i18next'
import { SearchInput } from '@/components/ui/search-input'
import type { StatusFilter } from '../types/home.types'

interface ProjectsSearchFilterProps {
  search: string
  onSearchChange: (value: string) => void
  statusFilter: StatusFilter
  onStatusFilterChange: (value: StatusFilter) => void
}

export function ProjectsSearchFilter({
  search,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
}: ProjectsSearchFilterProps) {
  const { t } = useTranslation()

  // Use translation keys for status filters
  const STATUS_FILTERS: { key: StatusFilter; labelKey: string }[] = [
    { key: 'ทั้งหมด', labelKey: 'status.all' },
    { key: 'กำลังดำเนินการ', labelKey: 'status.inProgress' },
    { key: 'เสร็จสิ้น', labelKey: 'status.completed' },
    { key: 'ยังไม่เริ่ม', labelKey: 'status.notStarted' },
  ]

  return (
    <div
      className="border-border bg-card flex flex-wrap items-center gap-3 border-b p-3"
      role="search"
      aria-label={t('actions.search')}
    >
      <SearchInput
        value={search}
        onChange={onSearchChange}
        placeholder={t('home.searchPlaceholder')}
        className="min-w-[200px] flex-1"
        aria-label={t('actions.search')}
      />

      <div className="flex gap-1" role="radiogroup" aria-label={t('actions.filter')}>
        {STATUS_FILTERS.map((filter) => (
          <button
            key={filter.key}
            onClick={() => {
              onStatusFilterChange(filter.key)
            }}
            role="radio"
            aria-checked={statusFilter === filter.key}
            className={
              statusFilter === filter.key
                ? 'border-primary bg-primary/10 text-primary focus:ring-ring rounded-full border px-3 py-1 text-xs font-semibold transition-colors focus:ring-2 focus:ring-offset-1 focus:outline-none'
                : 'border-border bg-background text-muted-foreground hover:bg-accent focus:ring-ring rounded-full border px-3 py-1 text-xs font-semibold transition-colors focus:ring-2 focus:ring-offset-1 focus:outline-none'
            }
          >
            {t(filter.labelKey)}
          </button>
        ))}
      </div>
    </div>
  )
}
